import {WorkspaceNs} from "@shared/types/workspace.namespace";
import {FeatureNs} from "@shared/types/feature.namespace";
import {ScreenNs} from "@shared/types/screen.namespace";
import {ProjectNs} from "@shared/types/project.namespace";
import {EstimationNs} from "@shared/types/estimation.namespace.ts";

export namespace PublicNs {

  /** Editor Routes */
  export enum PublicRouteEnums {
    EDITOR = 'Publish',
    ESTIMATION = 'Estimation',
    ERROR = 'Error',
    FEATURE = 'PublishFeature',
    FEATURE_SELECTED = 'PublishFeatureSelected',
    PAGE_SELECTED = 'PublishFeaturePageSelected',
    SCREEN = 'PublishScreen',
    SCREEN_SELECTED = 'PublishScreenSelected',
    ESTIMATION_FEATURE = 'EstimationFeature',
    ESTIMATION_FEATURE_SELECTED = 'EstimationFeatureSelected'
  }

  export interface CheckTokenRequest {
    projectId: string,
    token: string
  }

  export interface LoadProjectDataRequest {
    projectId: string,
    token: string,
    password: string
  }

  export interface PublicProjectData {
    workspace: WorkspaceNs.Workspace,
    project: ProjectNs.Project,
    publish: ProjectNs.PublishProjectResponse,
    features: FeatureNs.Feature[],
    screens: ScreenNs.Screen[]
  }

  export interface PublicEstimationData {
    workspace: WorkspaceNs.Workspace,
    project: ProjectNs.Project,
    estimationProject: EstimationNs.ProjectEstimation,
    groupSummary: EstimationNs.GroupSummary[],
    features: FeatureNs.Feature[],
  }
}
